const contractStatusReport = {
  label: "Contract Status",
  name: "contractStatusReport",
  parameters: [
    {
      name: "program",
      label: "Program Associated ID",
      type: "dbfield",
      db: ["hero", "data"],
      table: "Program",
      keyField: "ProgramAssociatedId",
      valueField: "ProgramAssociatedId",
      fields: ["Program.ProgramAssociatedId"],
      distinct: true,
      where: {
        ProgramAssociatedId: {
          null: false,
        },
      },
      sort: {
        ProgramAssociatedId: "asc",
      },
    },
  ],
};

export default contractStatusReport;
